import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "漫画分类", to: "/category/all" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dark, setDark] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const isDark = document.documentElement.classList.contains("dark");
    setDark(isDark);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const toggleDark = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
  };

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-200))]"
          : "bg-transparent"
      }`}
    >
      <nav className="container-site flex h-16 items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="漫画岛首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">
            漫画<span className="text-primary-500">岛</span>
          </span>
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`whitespace-nowrap text-sm transition-colors ${
                isActive(link.to)
                  ? "font-semibold text-primary-500"
                  : "text-foreground-800 hover:text-primary-500"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            type="button"
            onClick={toggleDark}
            aria-label={dark ? "切换到白天模式" : "切换到夜间模式"}
            className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors hover:bg-secondary-200 cursor-pointer"
          >
            <i className={dark ? "ri-sun-line text-lg" : "ri-moon-line text-lg"}></i>
          </button>
          <Link
            to="/category/all"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex cursor-pointer"
          >
            开始阅读
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 md:hidden cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-6 pt-2 backdrop-blur-md md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-md px-4 py-3 text-sm ${
                  isActive(link.to)
                    ? "bg-primary-100 font-semibold text-primary-600"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/all"
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-semibold text-background-50"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}